"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyStatus = void 0;
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVE"] = "ACTIVE";
    CompanyStatus["INACTIVE"] = "INACTIVE";
})(CompanyStatus || (exports.CompanyStatus = CompanyStatus = {}));
